module.exports = __webpack_public_path__ + "static/media/user.34befa78.png";